const axios = require('axios')

export const userLocationIpAddressInfo = async () => {
  let encodedURI = 'https://api.ipstack.com/check?access_key=5a3130c6edeaf2ab934b1c69e9e84500'
  return await axios
    .get(encodedURI)
    .then(function (response) {
      return {
        location: response.data.city + ', ' + response.data.region_code,
        lat: response.data.latitude,
        lng: response.data.longitude,
      }
    })
    .catch(function (error) {
      return {
        location: null,
        lat: null,
        lng: null,
      }
    })
}

export const discoverLocation = () => { }
